import React from 'react'
import { fetchFile } from '@pepper/utils/src/api/files/files'
import { Tooltip } from '../../atoms'
import { useShowMessage } from '../../providers'

import {
  CHARACTER_LIMIT,
  BREAKPOINTS
} from '@pepper/utils/src/constant/enum/responsive'

import { useResponsive } from '../../hooks'

import styles from './_.module.css'

type Props = {
  className?: string
  list: Attachment[]
  name?: string
  type?: 'text' | 'link' | 'ghost' | 'default' | 'primary' | 'dashed'
  isLoomField?: boolean
}

export const FileList: React.FC<Props> = ({
  className = '',
  list,
  type = 'text',
  name = null,
  isLoomField = false
}) => {
  const showMessage = useShowMessage()
  const { size } = useResponsive(BREAKPOINTS)

  const handleView = async (id: string) => {
    try {
      const response = await fetchFile({ id })
      const fileObjectURL = URL.createObjectURL(response.data)
      window.open(fileObjectURL)
    } catch (error) {
      showMessage({ type: 'error', message: 'Could not open file.' })
    }
  }

  return (
    <ol className={`${styles.fileList} ${className}`}>
      {list
        .filter(item => {
          if (isLoomField) return true
          return item.tag !== 'other_information'
        })
        .map(item => (
          <li key={item.id}>
            <span
              onClick={(): Promise<void> => handleView(item.id)}
              className={styles.filename}
              onKeyPress={() => {
                handleView(item.id)
              }}
              tabIndex={0}
              role="button"
            >
              <FileName fileName={name || item.name} size={size} />
            </span>
          </li>
        ))}
    </ol>
  )
}

const FileName: React.FC<{ fileName: string; size: ScreenSizeType }> = ({
  fileName,
  size
}) => {
  const fileExtension = fileName.split('.').pop()
  const mainFileName = fileName.split('.').slice(0, -1).join('')

  if (fileName.length < CHARACTER_LIMIT[size]) {
    return <span>{fileName}</span>
  }

  // assumption: length of file extension string is less than the minimum allowed character limit
  const fileNameToDisplay = `${truncatedString(
    mainFileName,
    CHARACTER_LIMIT[size] - (fileExtension?.length ?? 0)
  )}.${fileExtension}`

  return (
    <Tooltip placement="top" title={fileName}>
      <span className={styles.filename}>{`${fileNameToDisplay}`}</span>
    </Tooltip>
  )
}

// Truncating the filename
const truncatedString = (string: string, size: number) => {
  return string.length > size
    ? `${string.slice(0, size - '...'.length)}...`
    : string
}
